<template>
  <Sheet>
    <template #leading>
      <Sheet.Button :icon="CloseIcon" @click="close()" />
    </template>
    <template #title>Default privacy</template>
    <template #trailing>
      <Sheet.Button
        variant="primary"
        :icon="CheckmarkIcon"
        :disabled="loading || isBasic"
        @click="handleSave"
      />
    </template>

    <Sheet.Body class="pt-2">
      <DefaultFilePrivacyBody v-model="isPrivate" :is-basic="isBasic" />
    </Sheet.Body>
  </Sheet>
</template>

<script setup lang="ts">
import { Sheet, useSheet } from '@dacr/library'
import { CloseIcon, CheckmarkIcon } from '@dacr/icons'
import type { User } from '@/shared/graphql/legacy/generated'
import DefaultFilePrivacyBody from './DefaultFilePrivacyBody.vue'
import { useDefaultFilePrivacy } from './useDefaultFilePrivacy'

const { close } = useSheet()

const props = defineProps<{
  user: User
}>()

const { isPrivate, isBasic, loading, save } = useDefaultFilePrivacy(props.user)

const handleSave = async () => {
  if (await save()) close()
}
</script>
